// ExcelExporter.js
import * as XLSX from 'xlsx'

// // Formatea fecha (ISO string) a zona local y formato dd/mm/yyyy HH:mm
// const FormatLocalDateTime = (iso) => {
//   if (!iso) return ''
//   try {
//     const date = new Date(iso)
//     const fmt = new Intl.DateTimeFormat('es-MX', {
//       year: 'numeric', month: '2-digit', day: '2-digit',
//       hour: '2-digit', minute: '2-digit'
//     })
//     const parts = fmt.formatToParts(date)
//     const map = Object.fromEntries(parts.map(p => [p.type, p.value]))
//     return `${map.day}/${map.month}/${map.year} ${map.hour}:${map.minute}`
//   } catch {
//     return iso
//   }
// }

/**
 * Convierte una fecha ISO (ej. "2025-09-30T21:03:12") 
 * al formato "30/09/2025 21:03:12 hrs."
 *
 * @param {string} isoDate - Fecha en formato ISO.
 * @returns {string} Fecha formateada.
 */
const FormatDateTime = (isoDate) => {
  try {
    if (!isoDate) return ""

    const date = new Date(isoDate)

    const day = String(date.getUTCDate()).padStart(2, "0")
    const month = String(date.getUTCMonth() + 1).padStart(2, "0")
    const year = date.getUTCFullYear()

    const hours = String(date.getUTCHours()).padStart(2, "0")
    const minutes = String(date.getUTCMinutes()).padStart(2, "0")
    
    return `${day}/${month}/${year} ${hours}:${minutes}`
  } catch {
    return ""
  }
}

/**
 * Crea una hoja a partir de un arreglo de objetos asegurando el orden de columnas (headerOrder)
 * y aplicando ancho de columnas (colWidths).
 */
const JsonToSheet = (rows, headerOrder, headerLabels, colWidths = []) => {
  try {
    const safeRows = Array.isArray(rows) ? rows : []
    const safeHeaderOrder = Array.isArray(headerOrder) ? headerOrder : []

    const normalized = safeRows.map(r => {
      const o = {}
      safeHeaderOrder.forEach(k => {
        o[headerLabels?.[k] || k] = r?.[k] ?? ''
      })
      return o
    })

    const ws = XLSX.utils.json_to_sheet(normalized, { skipHeader: false })
    const range = XLSX.utils.decode_range(ws['!ref'])
    ws['!autofilter'] = { ref: XLSX.utils.encode_range(range) }
    if (colWidths.length) ws['!cols'] = colWidths.map(ch => ({ wch: ch }))
    return ws
  } catch (error) {
    console.error('JsonToSheet error:', error)
    // fallback mínimo
    const ws = XLSX.utils.aoa_to_sheet([['Error'], [String(error?.message || error || 'Error')]])
    return ws
  }
}

/**
 * Crea un libro con múltiples hojas y lo descarga.
 */
const BuildAndDownloadWorkbook = (filename, sheets) => {
  try {
    const wb = XLSX.utils.book_new()
    ;(Array.isArray(sheets) ? sheets : []).forEach(s => {
      if (s?.ws && s?.name) XLSX.utils.book_append_sheet(wb, s.ws, s.name)
    })
    XLSX.writeFile(wb, filename)
  } catch (error) {
    console.error('BuildAndDownloadWorkbook error:', error)
  }
}

/**
 * Construye una hoja combinando:
 * - metaRows: AOA (matriz de matrices) para bloques de metadatos
 * - rows + headerOrder/headerLabels (modo OBJETO)  **o**
 * - rows (AOA ya armada, con encabezados incluidos) si `headerOrder` no se provee y rows es AOA
 *
 * Si `headerOrder` está vacío y rows son objetos, se infiere del primer objeto.
 */
const BuildSheetWithMeta = ({ metaRows = [], rows = [], headerOrder = [], headerLabels = {}, colWidths = [] }) => {
  try {
    const meta = Array.isArray(metaRows) ? metaRows : []

    // ¿rows es AOA?
    const isAOA = Array.isArray(rows) && rows.length > 0 && Array.isArray(rows[0])

    // Si es AOA, asumimos que ya trae encabezados y datos listos
    if (isAOA) {
      const aoa = [...meta, [], ...rows]
      const ws = XLSX.utils.aoa_to_sheet(aoa)
      if (colWidths?.length) ws['!cols'] = colWidths.map(w => ({ wch: w }))
      return ws
    }

    // Modo OBJETO
    const objectRows = Array.isArray(rows) ? rows : []
    let order = Array.isArray(headerOrder) ? headerOrder : []

    // Si no se especificó headerOrder y tenemos al menos un objeto, lo inferimos del primero
    if ((!order || order.length === 0) && objectRows.length > 0 && rows[0] && typeof rows[0] === 'object') {
      order = Object.keys(rows[0])
    }

    // Asegura que order sea un array
    order = Array.isArray(order) ? order : []

    // Fila de encabezados (texto visible)
    const headerRow = order.map(k => headerLabels?.[k] ?? k)

    // Filas de datos en el orden deseado
    const dataRows = objectRows.map(r => order.map(k => r?.[k] ?? ''))

    const aoa = [
      ...meta,
      [],
      headerRow,
      ...dataRows
    ]

    const ws = XLSX.utils.aoa_to_sheet(aoa)
    if (colWidths?.length) ws['!cols'] = colWidths.map(w => ({ wch: w }))
    return ws
  } catch (error) {
    console.error('BuildSheetWithMeta error:', error)
    const ws = XLSX.utils.aoa_to_sheet([['Error al construir la hoja'], [String(error?.message || error || 'Error')]])
    return ws
  }
}

export { FormatDateTime, JsonToSheet, BuildAndDownloadWorkbook, BuildSheetWithMeta }










// import * as XLSX from 'xlsx'


// // Formatea fecha (ISO string) a zona local y formato dd/mm/yyyy HH:mm
// const FormatLocalDateTime = (iso) => {
//   if (!iso) return ''
//   try {
//     const date = new Date(iso)
//     // Ajusta si quieres una zona específica:
//     const fmt = new Intl.DateTimeFormat('es-MX', {
//       year: 'numeric', month: '2-digit', day: '2-digit',
//       hour: '2-digit', minute: '2-digit'
//     })
//     // "dd/mm/aaaa HH:mm"
//     const parts = fmt.formatToParts(date)
//     const map = Object.fromEntries(parts.map(p => [p.type, p.value]))
//     return `${map.day}/${map.month}/${map.year} ${map.hour}:${map.minute}`
//   } catch {
//     return iso
//   }
// }

// /**
//  * Crea una hoja a partir de un arreglo de objetos asegurando el orden de columnas (headerOrder)
//  * y aplicando ancho de columnas (colWidths).
//  * @param {Array<Object>} rows - datos (arreglo de objetos)
//  * @param {Array<string>} headerOrder - orden y claves exactas
//  * @param {Object<string,string>} headerLabels - etiquetas para los encabezados (mapea clave -> etiqueta)
//  * @param {Array<number>} colWidths - ancho de columnas en caracteres (opcional)
//  * @returns {XLSX.WorkSheet}
//  */
// const JsonToSheet = (rows, headerOrder, headerLabels, colWidths = []) => {
//     try {
//         // 1) Mapea rows a objetos con solo las claves en headerOrder, en ese orden
//         const normalized = rows.map(r => {
//             const o = {}
//             headerOrder.forEach(k => {
//             o[headerLabels?.[k] || k] = r?.[k] ?? '' // usa etiqueta como encabezado
//             })
//             return o
//         })

//         // 2) Crea hoja
//         const ws = XLSX.utils.json_to_sheet(normalized, { skipHeader: false })

//         // 3) AutoFilter (encabezado en fila 1)
//         const range = XLSX.utils.decode_range(ws['!ref'])
//         ws['!autofilter'] = { ref: XLSX.utils.encode_range(range) }

//         // 4) Anchos de columna
//         if (colWidths.length) {
//             ws['!cols'] = colWidths.map(ch => ({ wch: ch }))
//         }

//         return ws
//     } catch (error) {
        
//     }
// }

// /**
//  * Crea un libro con múltiples hojas y lo descarga.
//  * @param {string} filename - nombre con extensión .xlsx
//  * @param {Array<{name: string, ws: XLSX.WorkSheet}>} sheets
//  */
// const BuildAndDownloadWorkbook = (filename, sheets) => {
//     try {
//         const wb = XLSX.utils.book_new()
//         sheets.forEach(s => XLSX.utils.book_append_sheet(wb, s.ws, s.name))
//         XLSX.writeFile(wb, filename) // dispara descarga en navegador
//     } catch (error) {
        
//     }
// }

// const BuildSheetWithMeta = ({ metaRows = [], rows = [], headerOrder = [], headerLabels = {}, colWidths = [] }) => {
//   // Fila de encabezados (texto visible)
//   const headerRow = headerOrder.map(k => headerLabels[k] ?? k)

//   // Filas de datos en el orden deseado
//   const dataRows = rows.map(r => headerOrder.map(k => r[k] ?? ''))

//   // Ensamble final (meta, línea en blanco, headers, data)
//   const aoa = [
//     ...metaRows,         // e.g.: [ ['Curso:', 'Excel'], ['Grupo:', '5° A'], ['Evaluación:', 'Diagnóstico'] ]
//     [],
//     headerRow,
//     ...dataRows
//   ]

//   const ws = XLSX.utils.aoa_to_sheet(aoa)
//   if (colWidths?.length) ws['!cols'] = colWidths.map(w => ({ wch: w }))
//   return ws
// }

// export { FormatLocalDateTime, JsonToSheet, BuildAndDownloadWorkbook, BuildSheetWithMeta };